<div class="failed-upload-files-popup-container">
  <span *ngIf="data.title" class="failed-upload-files-popup-title">{{ data.title }}</span>
  <div class="failed-files" *ngIf="files?.length">
    <div *ngFor="let file of files" class="file">
      <u-icon class="icon-failed-file" *ngIf="file.icon" [model]="file.icon"></u-icon>
      <span class="name-file">{{ file.name }}</span>
      <span class="size-file">{{ (file.size / 1024).toFixed(2) }}KB</span>
    </div>
  </div>
  <div class="failed-upload-files-popup-button">
    <u-button
      *ngIf="data.secondaryButtonText"
      [label]="data.secondaryButtonText"
      [styles]="{ width: '120px' }"
      type="secondary"
      (onClick)="onSecondaryButton()"
    ></u-button>
    <u-button
      *ngIf="data.primaryButtonText"
      [label]="data.primaryButtonText"
      [styles]="{ width: '120px' }"
      type="primary"
      (onClick)="onPrimaryButton()"
    ></u-button>
  </div>
</div>
